module.exports = __webpack_public_path__ + "static/media/sj.67abb5e1.svg";